import { render, staticRenderFns } from "./CartItemDescription.vue?vue&type=template&id=0cdc1552&scoped=true"
import script from "./CartItemDescription.vue?vue&type=script&lang=js"
export * from "./CartItemDescription.vue?vue&type=script&lang=js"
import style0 from "./CartItemDescription.vue?vue&type=style&index=0&id=0cdc1552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc1552",
  null
  
)

export default component.exports